import type React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/app-shell';
import { ProtectedRoute, RequirePermission } from '@/auth/protected-route';
import { LoginPage } from '@/pages/login';
import { AcceptInvitePage } from '@/pages/accept-invite';
import { BatchesPage } from '@/pages/batches';
import { BatchDetailPage } from '@/pages/batch-detail';
import { ImportWizardPage } from '@/pages/import-wizard';
import { NotFoundPage } from '@/pages/not-found';
import { SettingsLayout } from '@/pages/settings/settings-layout';
import { VoicesSettingsPage } from '@/pages/settings/voices';
import { GenerationSettingsPage } from '@/pages/settings/generation';
import { PublishingSettingsPage } from '@/pages/settings/publishing';
import { ConnectionsSettingsPage } from '@/pages/settings/connections';
import { UsersSettingsPage } from '@/pages/settings/users';
import { AuditSettingsPage } from '@/pages/settings/audit';

/** SPEC §11 — /login, /accept-invite, / , /import, /batches/:id, /settings/*. */
export function App(): React.JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route index element={<BatchesPage />} />
          <Route element={<RequirePermission permission="batch.import" />}>
            <Route path="import" element={<ImportWizardPage />} />
          </Route>
          <Route path="batches/:id" element={<BatchDetailPage />} />

          {/* EMPLOYEEs may read settings; only SUPER_ADMIN can change them (SPEC §9). */}
          <Route element={<RequirePermission permission="settings.view" />}>
            <Route path="settings" element={<SettingsLayout />}>
              <Route index element={<Navigate to="/settings/voices" replace />} />
              <Route path="voices" element={<VoicesSettingsPage />} />
              <Route path="generation" element={<GenerationSettingsPage />} />
              <Route path="publishing" element={<PublishingSettingsPage />} />
              <Route path="connections" element={<ConnectionsSettingsPage />} />
              <Route element={<RequirePermission permission="user.manage" />}>
                <Route path="users" element={<UsersSettingsPage />} />
              </Route>
              <Route element={<RequirePermission permission="audit.view" />}>
                <Route path="audit" element={<AuditSettingsPage />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
